<mat-toolbar #navigation color="primary" [ngClass]="navbarClass">
  <div class="flex">
    <mat-icon (click)="onClickMenu()" class="menu-lateral">menu</mat-icon>
    <img data-cy="Home" routerLink="/home" class="logo-one"
      src="assets/yamaha-servicos-financeiros/yamaha-servicos-financeiros-1.png"
      alt="YAMAHA SERVIÇOS FINANCEIROS (1) (2).png">
    <img data-cy="Home" routerLink="/home" class="logo-two"
      src="assets/yamaha-servicos-financeiros/yamaha-servicos-financeiros-3.png"
      alt="YAMAHA SERVIÇOS FINANCEIROS (1) (2).png">
  </div>

  <div>
    <app-menu class="app-menu" eixo="horizontal"></app-menu>
  </div>

  <div class="feedback-container">
    <app-notifications [showIfPermission]="notificationPermition" class="notifications"></app-notifications>
    <div class="explorer-container mobile_explorer-container">
      <app-access-point class="app-access-point"></app-access-point>
      <app-avatar class="avatar mobile_hide"/>
    </div>
  </div>
</mat-toolbar>
